import { render, staticRenderFns } from "./Transection.vue?vue&type=template&id=ddd6bc52&"
import script from "./Transection.vue?vue&type=script&lang=js&"
export * from "./Transection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports